"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = void 0;
const react_1 = __importDefault(require("react"));
const CloseWhiteIcon_1 = __importDefault(require("./CloseWhiteIcon"));
const S = __importStar(require("./Notifications.styles"));
exports.Notifications = ({ type, title, message, closeModal, accessibilityLabelText, accessibilityHintText, }) => {
    return (react_1.default.createElement(S.Notifications, { importantForAccessibility: "yes", accessibilityLabel: accessibilityLabelText, accessibilityHint: accessibilityHintText },
        react_1.default.createElement(S.NotificationsContent, { type: type },
            react_1.default.createElement(S.NotificationsHeader, null,
                react_1.default.createElement(S.NotificationsTitle, { testID: "Notifications.Title", type: type }, title),
                react_1.default.createElement(S.TouchableOpacityBtn, { testID: "Notifications.CloseButton", onPress: closeModal },
                    react_1.default.createElement(CloseWhiteIcon_1.default, { height: "28px", width: "28px" }))),
            react_1.default.createElement(S.NotificationsInfo, { testID: "Notifications.Message", type: type }, message))));
};
